<template>
  <div class="p-1">
    <div
      v-for="(item, ind) in listSubMenuPromos"
      :key="ind"
      :style="{
        color: activeTab === item.id ? '#0d6efd' : 'black',
      }"
      class="cursor-pointer d-flex align-items-center font-weight-bold"
      @click="handleClick(item)"
      style="gap: 10px; padding: 10px 4px"
    >
      <feather-icon :icon="item.icon" size="18" />
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BIcon,
  BRow,
  BButton,
  BFormInput,
  BAvatar,
} from "bootstrap-vue";
import useToastHandler from "@/services/toastHandler";
import { formatTime } from "@/helpers/utils";
import { promotionSidebarMenu } from "@/@core/utils/enum/sidebar";

export default {
  components: {
    BIcon,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BAvatar,
  },
  data() {
    return {
      activeTab: 1,
      listSubMenuPromos: this.promotionSidebarMenu,
    };
  },
  computed: {},
  watch: {
    $route(val) {
      const path = val.path;
      this.handleCheckRoute(path);
    },
  },
  async mounted() {
    this.handleCheckRoute(this.$router.currentRoute.path);
  },
  methods: {
    handleClick(item) {
      this.activeTab = item.id;
      this.$router.push(item.route);
    },
    handleCheckRoute(path) {
      if (path === "/promotions") return (this.activeTab = 1);
      if (path.includes("deposit-match")) return (this.activeTab = 3);
      if (path.includes("money-back-specials")) return (this.activeTab = 4);
      if (path.includes("odd-boost")) return (this.activeTab = 6);
      if (path.includes("price-promotions")) return (this.activeTab = 7);
      if (path.includes("game")) return (this.activeTab = 8);
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
      formatTime,
      promotionSidebarMenu,
    };
  },
};
</script>

<style scoped></style>
